import React, { MouseEventHandler, useCallback, useState } from 'react';

import TimeItem from './components/TimeItem/TimeItem';
import TimeLineHooks from './components/TimeLineHooks/TimeLineHooks';

const TimeLine = () => {
  const [items, setItems] = useState<{ time: number; callBack: MouseEventHandler<HTMLDivElement> }[]>([]);
  const forwardSetItems = useCallback(
    (array: { time: number; callBack: MouseEventHandler<HTMLDivElement> }[]) => setItems(array),
    [],
  );

  return (
    <>
      <TimeLineHooks forwardSetItems={forwardSetItems} />
      {items.map(({ time, callBack }, index) => {
        return (
          <TimeItem key={time} time={time} callBack={callBack} index={index} />
        );
      })}
    </>
  );
};

export default TimeLine;
